import { buildVersion } from './buildInfo';

export async function formStarts() {
    await delay(300)
    window.adobeDataLayer.push({
        "event": "formStarts",
        "web": {
            "webInteraction": {
                "linkClicks": {
                    "value": 1
                },
                "name": "Form Start",
                "URL": window.location.href,
                "type": "other"
            }
        },
        "_icicibank": {
            "channelInfo": {
                "version": buildVersion,
                "name": "nli",
            },
            "formInfo": {
                "formName": "Salcorp Savings Account Lead Form",
                "formType": "Lead Generation",
                "formStepName": "details",
            },
            "pageInfo": {
                "language": "en",
                "pageType": "campaign",
                "virtualPageView": "no vpv",
                "journey": "na",
                "subJourney": "na",
                "subSubJourney": "na",
            },
            "productInfo": {
                "productName": "Salcorp Savings Account",
                "productCategory": "Accounts",
                "productSubCategory": "CASA"
            }
        }
    });

    return window.adobeDataLayer;
}


export function eventClick(ctaName, type, region, url) {
    window.adobeDataLayer.push({
        "event": "ctaClick", "web": { "webInteraction": { "linkClicks": { "value": 1 }, "name": `cta`, "URL": url || window.location.href || "na", "type": "other" } }, "_icicibank": {
            "channelInfo": {
                version: buildVersion,
                name: "nli",
            }, "dateTime": {
                "timeParting" : getCurrentTimeParting(),
                "unixTimestamp": Date.now()
            }, "ctaInfo":
                { "ctaName": `${ctaName}`, "ctaRegion": region, "ctaType": type, "ctaURL":  url || window.location.href || "na", "faqClicks": 0 }, "pageInfo": {
                    "language": "en", "pageType": "campaign", "virtualPageView": "no vpv", "journey": "na", "subJourney": "na", "subSubJourney": "na",
                },
            "productInfo": {
                "productName": "Salcorp Savings Account",
                "productCategory": "Accounts",
                "productSubCategory": "CASA"
            }
        }
    });
}



export function eventWithFormInfo(ctaName, type, region, url, inputs) {
    window.adobeDataLayer.push({
        "event": "ctaClick", "web": { "webInteraction": { "linkClicks": { "value": 1 }, "name": `cta`, "URL": url || window.location.href || "na",  "type": type == "link" && ctaName == "terms & conditions" ? "download": "other" } }, "_icicibank": {
            "formInfo": {
                "formName": "Salcorp Savings Account Lead Form",
                "formType": "Lead Generation",
                "formStepName": "details",
                "formFields": inputs ? `pincode:${inputs.pincode || "na"} | branch:${inputs.branch || "na"}` : "na",
                "bankNameDetail": "na",
            },
            "channelInfo": {
                version: buildVersion,
                name: "nli",
            }, "dateTime": {
                "timeParting" : getCurrentTimeParting(),
                "unixTimestamp": Date.now()
            }, "ctaInfo":
                { "ctaName": `${ctaName}`, "ctaRegion": region, "ctaType": type, "ctaURL":  url || window.location.href || "na", "faqClicks": 0 }, "pageInfo": {
                    "language": "en", "pageType": "campaign", "virtualPageView": "no vpv", "journey": "na", "subJourney": "na", "subSubJourney": "na",
                },
            "productInfo": {
                "productName": "Salcorp Savings Account",
                "productCategory": "Accounts",
                "productSubCategory": "CASA"
            }
        }
    });
}

export async function formSubmitEvent(inputs, eligible) {

    await delay(300)
    window.adobeDataLayer.push({
        "event": "formSuccess",
        "web": {
            "webInteraction": {
                "linkClicks": {
                    "value": 1
                },
                "name": "Form Submit",
                "URL": window.location.href,
                "type": "other"
            }
        },
        "_icicibank": {
            "formInfo": {
                "formName": "Salcorp Savings Account Lead Form",
                "formType": "Lead Generation",
                "formStepName": eligible ? "eligible thankyou" : "not eligible thankyou",
                "formFields": inputs ? `entity:${inputs.entity || "na"} | pincode:${inputs.pincode || "na"} | branch:${inputs.branch || "na"}` : "na",
                "bankNameDetail": "na",
            },
            "channelInfo": {
                "version": buildVersion,
                "name": "nli",
            },
            "pageInfo": {
                "language": "en",
                "pageType": "campaign",
                "virtualPageView": "no vpv",
                "journey": "na",
                "subJourney": "na",
                "subSubJourney": "na",
            },
            "userInfo": {
                "accountType": "na",
                "userType": "na",
                "hashedMobile": "na",
                "hashedEmail": "na"
            },
            authenticationInfo: {
                otpAuthentication: 1
            },
            "productInfo": {
                "productName": "Salcorp Savings Account",
                "productCategory": "Accounts",
                "productSubCategory": "CASA"
            }
        }
    })
}

export function faqClick(ctaName) {
    window.adobeDataLayer.push({
        "event": "ctaClick", "web": { "webInteraction": { "linkClicks": { "value": 1 }, "name": `cta`, "URL": window.location.href, "type": "other" } }, "_icicibank": {
            "channelInfo": {
                version: buildVersion,
                name: "nli",
            }, "dateTime": {
                "timeParting" : getCurrentTimeParting(),
                "unixTimestamp": Date.now()
            }, "ctaInfo":
                { "ctaName": ctaName, "ctaRegion": "footer", "ctaType": "accordion", "ctaURL": "na", "faqClicks": 1 }, "pageInfo": {
                    "language": "en", "pageType": "campaign", "virtualPageView": "no vpv", "journey": "na", "subJourney": "na", "subSubJourney": "na",
                },
            "productInfo": {
                "productName": "Salcorp Savings Account",
                "productCategory": "Accounts",
                "productSubCategory": "CASA"
            }
        }
    });
}


export function fieldErrorEvent(error, fieldName) {
    // console.log(error,"fielderror")
    
    window.adobeDataLayer.push({ "event": "formFieldError", "web": { "webInteraction": { "linkClicks": { "value": 1 }, "name": "Form Field Error", "URL": window.location.href, "type": "other" } }, 
    "_icicibank": { "formInfo": { "formName": "Salcorp Savings Account Lead Form", "formFields": fieldName, "formType": "Lead Generation", "formStepName": "details", }, "channelInfo": { version: buildVersion, "name": "nli", }, "pageInfo": { "language": "en", "pageType": "campaign", "virtualPageView": "no vpv", "journey": "na", "subJourney": "na", "subSubJourney": "na", }, "productInfo": {
        "productName": "Salcorp Savings Account",
        "productCategory": "Accounts",
        "productSubCategory": "CASA"
    }, "errorInfo": { "errorType": "form field error", "errorDetails": error } } });
}

// This will trigger when the "apply now" button is clicked and there are field errors
export function submitErrorEvent(errors) {

    let errorTitleDesc = "";
    let errorFields = "";
    for (const [key, value] of Object.entries(errors)) {
        errorTitleDesc += `${key}:${value}|`
        errorFields += `${key}|`
    }

    window.adobeDataLayer.push({
        "event": "formFieldError", "web": { "webInteraction": { "linkClicks": { "value": 1 }, "name": "Form Field Error", "URL": window.location.href, "type": "other" } }, "_icicibank": {
            "dateTime": { "unixTimestamp": Date.now() }, "formInfo": { "formName": "Salcorp Savings Account Lead Form", "formFields": errorFields.slice(0, errorFields.length - 1), "formType": "Lead Generation", "formStepName": "details", }, "channelInfo": { version: buildVersion, "name": "nli", }, "pageInfo": { "language": "en", "pageType": "campaign", "virtualPageView": "no vpv", "journey": "na", "subJourney": "na", "subSubJourney": "na", },
            "productInfo": {
                "productName": "Salcorp Savings Account",
                "productCategory": "Accounts",
                "productSubCategory": "CASA"
            },
            "errorInfo": { "errorType": "form field error", "errorDetails": errorTitleDesc.slice(0, errorTitleDesc.length - 1) }
        }
    });

}

// This will trigger when the fields are valid but the lead creation fails
export function formSubmissionFailEvent() {
    window.adobeDataLayer.push({
        "event": "formSubmissionFail", "web": { "webInteraction": { "linkClicks": { "value": 1 }, "name": "Form Submission Fail", "URL": window.location.href, "type": "other" } }, "_icicibank": {
            "formInfo": { "formName": "Salcorp Savings Account Lead Form", "formType": "Lead Generation", }, "channelInfo": { version: buildVersion, "name": "nli", }, "pageInfo": { "language": "en", "pageType": "campaign", "virtualPageView": "no vpv", "journey": "na", "subJourney": "na", "subSubJourney": "na", }, "productInfo": {
                "productName": "Salcorp Savings Account",
                "productCategory": "Accounts",
                "productSubCategory": "CASA"
            }, "errorInfo": { "errorType": "Form Submission Fail", "errorDetails": "otp:exceeded attempts or other" }
        }
    });
}


export function formIntermediateEventOTP(otpStatus) {
    window.adobeDataLayer.push({
        "event": "formIntermediate", "web": { "webInteraction": { "linkClicks": { "value": 1 }, "name": "Form Intermediate", "URL": window.location.href, "type": "other" } }, "_icicibank": {
          "formInfo": { "formName": "Salcorp Savings Account Lead Form", "formFields": "otp", "formType": "Lead Generation", "formStepName": `${otpStatus} otp`, "bankNameDetail": "na", }, "pageInfo": { "language": "en", "pageType": "campaign", "virtualPageView": "no vpv", "journey": "na", "subJourney": "na", "subSubJourney": "na", }, "userInfo": { "accountType": "na" }, authenticationInfo: { otpAuthentication: 1 }, "productInfo": {
                "productName": "Salcorp Savings Account",
                "productCategory": "Accounts",
                "productSubCategory": "CASA"
            },
        }
    });
}

export function formAbandonEvent(lastAcField) {

    window.adobeDataLayer.push({ "event": "formAbandonment", "web": { "webInteraction": { "linkClicks": { "value": 1 }, "name": "Form abandonment", "URL": window.location.href, "type": "other" } }, "_icicibank": {  "formInfo": { "formName": "Salcorp Savings Account Lead Form", "formFields": "na", "formType": "Lead Generation", "bankNameDetail": "na", "formStepName": "details", "lastAccessedField": lastAcField, }, "channelInfo": { version: buildVersion, "name": "nli" }, "pageInfo": { "language": "en", "pageType": "campaign", "virtualPageView": "no vpv", "journey": "na", "subJourney": "na", "subSubJourney": "na", }, "userInfo": { "accountType": "na", "userType": "na", "hashedMobile": "na", "hashedEmail": "na" },  "productInfo": {
        "productName": "Salcorp Savings Account",
        "productCategory": "Accounts",
        "productSubCategory": "CASA"
        }
}

});

}


function delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

function flattenObject(obj) {
    const result = {};

    function recurse(current, parentKey = '') {
        for (const key in current) {
            const newKey = parentKey ? `${parentKey}.${key}` : key;

            if (typeof current[key] === 'object' && current[key] !== null) {
                recurse(current[key], newKey);
            } else {
                result[newKey] = current[key];
            }
        }
    }

    recurse(obj);
    return result;
}

function getCurrentTimeParting() {
    const date = new Date();
  
    // Extract components
    const year = date.getFullYear();
    const month = date.toLocaleString('default', { month: 'long' });
    const dayDate = date.getDate();
    const dayName = date.toLocaleString('default', { weekday: 'long' });
    const hours = date.getHours();
    const minutes = date.getMinutes();
    // Format time in 12-hour format and determine AM or PM
    const timeSuffix = hours >= 12 ? 'PM' : 'AM';
    const formattedHour = ((hours + 11) % 12 + 1); // Convert 24h to 12h format
    const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
  
    // Construct the timeParting string
    const timeParting = `year=${year} | month=${month} | date=${dayDate} | day=${dayName} | time=${formattedHour}:${formattedMinutes} ${timeSuffix}`;
  
    return timeParting;
  }
  
  
